import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    playbuttonFirstColor: { type: String, default: "#e77817" },
    playbuttonSecondColor: { type: String, default: "#f2f2f3" },
    firstColor: { type: String, default: "#e77817" },
    secondColor: { type: String, default: "#f2f2f3" },
    thirdColor: { type: String, default: "#292929" }
  }

  connect() { this.updatePreview() }

  updatePreview() {
    // Play button
    this.element.querySelector(".player-preview-playbutton").style.setProperty("--playbutton-color", this.playbuttonFirstColorValue)
    this.element.querySelector(".player-preview-playbutton").style.setProperty("--playbutton-hover-color", this.playbuttonSecondColorValue)
    // Progress bar
    this.element.querySelector(".player-preview-progress__bar").style.backgroundColor = this.firstColorValue
    //  Menu bar
    this.element.querySelector(".player-preview-menubar").style.backgroundColor = this.thirdColorValue
    this.element.querySelector(".player-preview-menubar").style.color = this.secondColorValue
    // Menu bar controls
    this.element.querySelector(".player-preview-menubar__playbutton-triangle").style.borderLeftColor = this.secondColorValue
  }

  playbuttonFirstColorValueChanged() { this.updatePreview() }
  playbuttonSecondColorValueChanged() { this.updatePreview() }
  firstColorValueChanged() { this.updatePreview() }
  secondColorValueChanged() { this.updatePreview() }
  thirdColorValueChanged() { this.updatePreview() }
}
